module.exports = __webpack_public_path__ + "img/img-receive-sec-03-01.png";